import React from 'react';
import { Image, Slideshow } from 'components';
import { media } from '../utils/media';

const SectionThreeIcons = ({content})=> {
  return (
    <>
    <h2 className='section-title mt-90 mb-50'>{content.title}</h2>
    <div className='section-icons mb-50'>
      <Slideshow>
        <div className='icon-wrapper'>
          <Image url={media(content.icon1)} alt={`Invisible aligners for ${content.icon1text}`} />
          <p><b dangerouslySetInnerHTML={{ __html: content.icon1text }}></b></p>
        </div>
        <div className='icon-wrapper'>
          <Image url={media(content.icon1)} alt={`Invisible aligners for ${content.icon1text}`} />
          <p><b dangerouslySetInnerHTML={{ __html: content.icon2text }}></b></p>
        </div>
        <div className='icon-wrapper'>
          <Image url={media(content.icon1)} alt={`Invisible aligners for ${content.icon1text}`} />
          <p><b dangerouslySetInnerHTML={{ __html: content.icon3text }}></b></p>
        </div>
      </Slideshow>
    </div>
    </>
  );
}

export default SectionThreeIcons;